export default __webpack_public_path__ + "static/pro-pic-mobile-cc7e9f84ac7d2ff1693d6989e2bc7471.png";